import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'elementNull',
   
})
export class ElementNullPipe implements PipeTransform {
  /**
   * Converte i null in --, si si passa il booleano a true allora converte in ----/--/--
   * @example
   * - <span>{{item.nome | elementNull}}</span>
   * - <span>{{item.dataDiNascita | elementNull:true}}</span>
   *
   */
  transform<T>(element: T, isDate?: boolean): T | string {
    if (
      element == null ||
      element == undefined ||
      element == 'null' ||
      element == '' ||
      element == ' ' ||
      (element instanceof String ? element.trim() == '' : !element)
    ) {
      //MOCK
      return isDate ? '---- / -- / --' : '-';
    } else {
      return element;
    }
  }
}
